import { Validator } from 'services/validator'
import {
  SUBJECT_FIELD,
  COMMENTS_FIELD,
  NAME_FIELD,
  PHONE_FIELD,
  EMAIL_FIELD,
  ZIP_CODE_FIELD,
  STORE_LOCATION,
  SUBJECT_VALIDATION_MESSAGE,
  COMMENTS_VALIDATION_MESSAGE,
  NAME_VALIDATION_MESSAGE,
  PHONE_VALIDATION_MESSAGE,
  EMAIL_VALIDATION_MESSAGE,
  ZIP_CODE_VALIDATION_MESSAGE,
  STORE_LOCATION_VALIDATION_MESSAGE,
  REQUIRED_FIELDS_MESSAGE,
  FLEET_REQUIRED_FIELDS
} from './constants'

export const contactValidator = Validator.combineValidators(
  {
    [SUBJECT_FIELD]: {
      validators: Validator.required(),
      errorMessage: SUBJECT_VALIDATION_MESSAGE
    },
    [NAME_FIELD]: {
      validators: [
        Validator.required(),
        Validator.firstName()
      ],
      errorMessage: NAME_VALIDATION_MESSAGE
    },
    [PHONE_FIELD]: {
      validators: [
        Validator.required(),
        Validator.primaryPhone()
      ],
      errorMessage: PHONE_VALIDATION_MESSAGE
    },
    [EMAIL_FIELD]: {
      validators: [
        Validator.required(),
        Validator.email()
      ],
      errorMessage: EMAIL_VALIDATION_MESSAGE
    },
    [ZIP_CODE_FIELD]: {
      validators: [
        Validator.required(),
        Validator.zipCode()
      ],
      errorMessage: ZIP_CODE_VALIDATION_MESSAGE
    },
    [STORE_LOCATION]: {
      validators: (value, values, { storeLocationRequired }) =>
        !storeLocationRequired || Boolean(value),
      errorMessage: STORE_LOCATION_VALIDATION_MESSAGE
    },
    [COMMENTS_FIELD]: {
      validators: [
        Validator.required(),
        Validator.length(10)
      ],
      errorMessage: COMMENTS_VALIDATION_MESSAGE
    }
  }
)

export const fleetValidator = Validator.combineValidators(
  {
    [NAME_FIELD]: {
      validators: [
        Validator.required(),
        Validator.firstName()
      ],
      errorMessage: NAME_VALIDATION_MESSAGE
    },
    [EMAIL_FIELD]: {
      validators: [
        Validator.required(),
        Validator.email()
      ],
      errorMessage: EMAIL_VALIDATION_MESSAGE
    },
    [PHONE_FIELD]: {
      validators: [
        Validator.required(),
        Validator.primaryPhone()
      ],
      errorMessage: PHONE_VALIDATION_MESSAGE
    },
    [ZIP_CODE_FIELD]: {
      validators: [
        Validator.required(),
        Validator.zipCode()
      ],
      errorMessage: ZIP_CODE_VALIDATION_MESSAGE
    },
    _error: {
      validators: (value, values) => FLEET_REQUIRED_FIELDS.every(key => values[key]),
      errorMessage: REQUIRED_FIELDS_MESSAGE
    }
  }
)

